"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CtaButtonGroupType = void 0;
var CtaButtonGroupType;
(function (CtaButtonGroupType) {
    CtaButtonGroupType["BUTTON_REVERSE_RIGHT"] = "BUTTON_REVERSE_RIGHT";
    CtaButtonGroupType["BUTTON_REVERSE_LEFT"] = "BUTTON_REVERSE_LEFT";
})(CtaButtonGroupType = exports.CtaButtonGroupType || (exports.CtaButtonGroupType = {}));
//# sourceMappingURL=CtaButtonGroupProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/CtaButtonGroup/CtaButtonGroupProps.js
// module id = 161
// module chunks = 8